import { Card, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import crudsService from "services/cruds-service";
import MDNumberInput from "components/MDNumberInput";


function UpdateDeviceSettings({ device_id, identifier }) {

    const [settingType, setSettingType] = useState('');
    const [uploadTime, setUploadTime] = useState('');
    const [alarmHeight, setAlarmHeight] = useState('');
    const [info, setInfo] = useState(null)

    useEffect(() => {
        callApi();
    }, [])

    const callApi = async () => {
        let resp = await crudsService.getDeviceSetting(device_id)
        if (resp.success) {
            setInfo(resp.data)
        }
    }

    const updateDeviceSetting = async (e) => {
        e.preventDefault();

        try {

            let value = settingType == 'upload_time' ? uploadTime : alarmHeight
            let resp = await crudsService.updateDeviceSetting({
                device_id: device_id,
                identifier,
                type: settingType,
                value: Number(value)
            })

            if (resp.success) {
                callApi();
            }
            toast.info(resp.msg)

        } catch (error) {
            console.error('updateDeviceSetting error', error)
            toast.error(error.error)
        }
    }


    return (
        <Card style={{ marginTop: '1rem' }}>
            <MDBox display="flex" flexDirection="column" px={3} my={2}>
                <MDTypography fontWeight="bold" >Update Device Setting</MDTypography>
                {
                    info ?
                        <>
                            {info.upload_time ? <MDTypography component="p">🕒 Sends an update every <strong>{info.upload_time} hour(s)</strong><br /></MDTypography> : ''}
                            {info.alarm_height ? <MDTypography component="p">🚨 Triggers alert when <strong>{info.alarm_height} inches</strong> from the top<br /></MDTypography> : ''}
                            {info.pending_update ? (
                                <MDTypography component="p">⚠️ An update is already waiting to be applied. It will take effect the next time the device checks in.</MDTypography>
                            ) : (
                                <MDTypography component="p">✅ No updates are pending.</MDTypography>
                            )}
                        </>
                        : ''
                }
                <div className="form-group" style={{ display: 'flex', gap: '10px', color: '#fff', alignItems: 'center', marginTop: '10px' }}>
                    <MDTypography component="p" htmlFor="settingType" sx={{ fontSize: '0.875rem' }}>What would you like to update?</MDTypography>
                    <FormControl>
                        <InputLabel id="settingType" sx={{ fontSize: '0.875rem' }}>SettingType</InputLabel>
                        <Select
                            labelId="settingType"
                            id="settingType"
                            value={settingType}
                            label="SettingType"
                            onChange={(e) => setSettingType(e.target.value)}
                            sx={{
                                '& .MuiSelect-select': {
                                    minHeight: '3em !important'
                                }
                            }}
                        >
                            <MenuItem value="">Select an option</MenuItem>
                            <MenuItem value="upload_time">How often it sends updates (in hours)</MenuItem>
                            <MenuItem value="alarm_height">When to trigger a tank alert (inches from top)</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                {settingType === 'upload_time' && (
                    <div className="form-group" style={{ display: 'flex', gap: '10px', color: '#fff', alignItems: 'center', marginTop: '10px' }}>
                        <MDTypography component="p" htmlFor="uploadTime" sx={{ fontSize: '0.875rem' }}>New update frequency (hours)</MDTypography>
                        <MDNumberInput
                            id="uploadTime"
                            min="1"
                            max="24"
                            value={uploadTime}
                            onChange={(e, val) => {
                                e.preventDefault()
                                setUploadTime(val)
                            }}
                            placeholder="e.g., 6"
                        />
                    </div>
                )}

                {settingType === 'alarm_height' && (
                    <div className="form-group" style={{ display: 'flex', gap: '10px', color: '#fff', alignItems: 'center', marginTop: '10px' }}>
                        <MDTypography component="p" htmlFor="alarmHeight" sx={{ fontSize: '0.875rem' }}>New alert threshold (inches)</MDTypography>
                        <MDNumberInput
                            type="number"
                            id="alarmHeight"
                            min="1"
                            value={alarmHeight}
                            onChange={(e, val) => {
                                e.preventDefault()
                                setAlarmHeight(val)
                            }}
                            placeholder="e.g., 20"
                        />
                    </div>
                )}

                <MDButton variant="gradient" color="dark" sx={{ width: '15%', marginTop: '10px' }} onClick={(e) => updateDeviceSetting(e)}>Send Update</MDButton>
            </MDBox>
        </Card>
    )

}

export default UpdateDeviceSettings;